export enum DispatchType {
  IMP = 'import',
  EXP = 'export',
  VAN = 'van',
  BOOK = 'booking'
}
